<template>
  <v-card class="px-2 manhole-level-detail" tile flat>
    <v-card class="caption text--secondary mb-1" flat height="20">
      {{ `${observatory.lat},${observatory.lng}` }}
    </v-card>

    <ManholeChart
      v-if="!isDeficit"
      :height="isMobile ? 200 : 250"
      :observatory="observatory"
      :timeSeries="timeSeries"
      :currentLevel="currentLevel != null ? parseFloat(currentLevel) : null"
    />
    <v-card
      class="d-flex align-center justify-end mt-2"
      flat
      v-if="currentLevel !== null"
    >
      <v-card width="30" height="18" color="#3D8AFF"></v-card>
      <div class="caption ml-4">現在水位 {{ currentLevel }} m</div>
    </v-card>
    <v-card
      v-if="isDeficit || isMentenance"
      tile
      flat
      height="180"
      class="d-flex justify-center align-center"
    >
      {{ isDeficit ? "休止もしくは欠測しています" : "機器メンテナンス中" }}
    </v-card>

    <v-simple-table
      dense
      fixed-header
      :height="isMobile ? 'calc(100dvh - 400px)' : 'calc(100dvh - 360px)'"
      class="mt-2"
      v-if="rows.length > 0"
    >
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">日時</th>
            <th class="text-left">水位(m)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(ts, i) in rows" :key="i">
            <td :class="{ 'manhole-predict': ts.type === 'forecast' }">
              {{ ts.time }}
            </td>
            <td>
              <v-chip
                :color="getLevelColor(ts.status)"
                :dark="ts.status !== 'normal'"
              >
                {{ ts.level }}
              </v-chip>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
import moment from "moment";
import ManholeChart from "./ManholeChart";

export default {
  name: "ManholeLevelDetail",

  components: {
    ManholeChart
  },

  data() {
    return {
      credentials: null
    };
  },

  computed: {
    isMobile() {
      return this.$route.path === "/mobile";
    },
    observatory() {
      return this.$store.getters.selectedObservatory;
    },
    isDeficit() {
      if (this.currentLevel !== null) {
        return false;
      }
      return (
        this.observatory.timeSeries === undefined ||
        this.observatory.timeSeries.length === 0
      );
    },
    warningLevel() {
      return this.observatory.warningLevel;
    },
    dangerousLevel() {
      return this.observatory.dangerousLevel;
    },
    currentLevel() {
      const levels = this.timeSeries
        .filter(r => r.type === "real")
        .map(r => r.level)
        .filter(l => l !== undefined);
      if (levels.length === 0) {
        return null;
      } else {
        return levels[levels.length - 1].toFixed(2);
      }
    },
    baseDate() {
      return this.$store.getters.baseDate;
    },
    rows() {
      return this.timeSeries
        .map(r => {
          const time = moment
            .utc(r.date, "YYYYMMDDHHmm")
            .local()
            .format("MM/DD HH:mm");
          let status = "normal";
          if (r.level !== undefined) {
            if (
              this.dangerousLevel !== undefined &&
              r.level >= this.dangerousLevel
            ) {
              status = "dangerous";
            } else if (
              this.warningLevel !== undefined &&
              r.level >= this.warningLevel
            ) {
              status = "warning";
            }
          }
          return {
            time: time,
            level:
              r.level !== undefined ? parseFloat(r.level).toFixed(2) : "---",
            status: status,
            type: r.type
          };
        })
        .slice()
        .reverse();
    },
    isMentenance() {
      return this.observatory.is_mentenance === true;
    },
    timeSeries() {
      if (this.isMentenance === true) {
        return [];
      }
      if (this.observatory.timeSeries === undefined) {
        return [];
      } else {
        return this.observatory.timeSeries;
      }
    }
  },

  methods: {
    getLevelColor(status) {
      if (status === "dangerous") {
        return "#AD02AD";
      } else if (status === "warning") {
        return "#FFA500";
      } else {
        return "transparent";
      }
    },
    scrollNow() {
      const tableWrapper = this.$el.getElementsByClassName(
        "v-data-table__wrapper"
      )[0];
      if (tableWrapper === undefined) {
        return;
      }

      const firstRealIndex = this.rows.findIndex(r => r.type === "real");
      if (firstRealIndex < 0) {
        tableWrapper.scroll({ top: 0, behavior: "instant" });
        return;
      }

      const rowElements = tableWrapper.querySelectorAll("tbody tr");
      const targetRow = rowElements[firstRealIndex];
      if (targetRow === undefined) {
        tableWrapper.scroll({ top: 0, behavior: "instant" });
        return;
      }

      const headerHeight =
        tableWrapper.querySelector("thead")?.offsetHeight || 0;
      const top = Math.max(targetRow.offsetTop - headerHeight, 0);
      tableWrapper.scroll({ top: top, behavior: "instant" });
    }
  },

  watch: {
    rows() {
      setTimeout(() => {
        this.scrollNow();
      }, 500);
    }
  },
  mounted() {
    setTimeout(() => {
      this.scrollNow();
    }, 500);
  }
};
</script>

<style lang="scss" scoped>
.manhole-level-detail {
  tbody td {
    background: #eee;
  }
  tbody tr:nth-child(odd) td {
    background: #fff;
  }
}
</style>

<style lang="scss">
.manhole-level-detail {
  .v-data-table__wrapper {
    overflow-y: auto !important;
  }
}
.v-chip.v-size--default {
  height: 22px !important;
}
.manhole-predict {
  color: blue;
}
</style>
